(function(){
  "use strict";

  if (window.__PO_K5_BALAKALLPA_TEXTS_20260303__) return;
  window.__PO_K5_BALAKALLPA_TEXTS_20260303__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AXIS_LEX_ID = "balakallpa";
  var ROOT_SEL = '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  function clampStr(v){ return (v == null) ? "" : String(v); }
  function qsa(root, sel){ try{ return Array.prototype.slice.call(root.querySelectorAll(sel) || []); }catch(e){ return []; } }
  function qs(root, sel){ try{ return root.querySelector(sel); }catch(e){ return null; } }

  function normLang(raw){
    var v = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (v === "fr" || v.indexOf("fr") === 0) return "fr";
    if (v === "en" || v.indexOf("en") === 0) return "en";
    if (v === "es" || v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang(){
    try{
      var v = normLang(localStorage.getItem(STORAGE_KEY) || "");
      if (v) return v;
    }catch(e){}
    try{
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT) || "");
      if (v2) return v2;
    }catch(e){}
    return "";
  }

  function detectBrowserLang(){
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      return normLang(n) || "fr";
    }catch(e){
      return "fr";
    }
  }

  function getLang(){ return readStoredLang() || detectBrowserLang() || "fr"; }

  function storeLang(lang){
    var v = normLang(lang) || "fr";
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{ if (document && document.documentElement) document.documentElement.setAttribute("lang", v); }catch(e){}
    return v;
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++) if (arr[i] && arr[i].id === id) return arr[i];
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{ if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]); }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    try{ if (entry.defs && entry.defs[lang] && entry.defs[lang].short) return clampStr(entry.defs[lang].short); }catch(e){}
    try{ if (entry.defs && entry.defs[lang]) return clampStr(entry.defs[lang]); }catch(e){}
    try{ if (entry["definition_short_" + lang]) return clampStr(entry["definition_short_" + lang]); }catch(e){}
    try{ if (entry["definition_" + lang]) return clampStr(entry["definition_" + lang]); }catch(e){}
    try{ if (entry.definition_fr) return clampStr(entry.definition_fr); }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    try{ if (entry.defs && entry.defs[lang] && entry.defs[lang].long) return clampStr(entry.defs[lang].long); }catch(e){}
    try{ if (entry["usage_" + lang]) return clampStr(entry["usage_" + lang]); }catch(e){}
    try{ if (entry["definition_oper_" + lang]) return clampStr(entry["definition_oper_" + lang]); }catch(e){}
    try{ if (entry["definition_long_" + lang]) return clampStr(entry["definition_long_" + lang]); }catch(e){}
    try{ if (entry.usage_fr) return clampStr(entry.usage_fr); }catch(e){}
    try{ if (entry.definition_oper_fr) return clampStr(entry.definition_oper_fr); }catch(e){}
    return "";
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(s){ return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;
    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);
    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{ if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) return window.PO_LEXICON_META.lexique_simplifie_fr.slice(); }catch(e){}
    try{ if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) return window.PO_LEXICON.meta.lexique_simplifie_fr.slice(); }catch(e){}
    try{ if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice(); }catch(e){}
    try{ if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)) return window.PO_LEXIQUE_SIMPLIFIE_FR.slice(); }catch(e){}
    return [
      "Posœnnoïsme","Posœnnoïa","Organon posœnnoïal","Katûvýsissence","Katûvýs","Katûsýs",
      "Balakallpa","Threnisqun","Katûvýsqun","RéZonans","Synchrêssion","Accords posœnnoïaux",
      "Sujet Pluriel","Posœnnomia","Posœnnoïamie","Katûpirsia","Àpákan","MOCoN"
    ];
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function buildProtectRegex(){
    var base = getSimplifiedLexiqueFRList();
    var terms = [];
    var seen = Object.create(null);
    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }
    terms.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;
    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }catch(e){ return null; }
  }

  function ensureProtectEngineReady(){
    var key = "lex:none";
    try{
      var l = getSimplifiedLexiqueFRList();
      key = "lex:" + (l ? l.length : 0);
    }catch(e){ key = "lex:none"; }
    if (__PO_PROTECT_CACHE__.key === key && __PO_PROTECT_CACHE__.re) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegex();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
      if (cls.indexOf("po-lex-locknode") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){ return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch); }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;
    var txt = textNode.nodeValue;
    if (!txt) return;
    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;
    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;
      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));
      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));
      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);
      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));
      last = end;
      if (!match.length) break;
    }
    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);
    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;
    var NodeFilterRef = (typeof NodeFilter !== "undefined") ? NodeFilter : (window && window.NodeFilter ? window.NodeFilter : null);
    if (!NodeFilterRef) return String(html);
    var walker;
    try{
      walker = document.createTreeWalker(root, NodeFilterRef.SHOW_TEXT, {
        acceptNode: function(n){
          if (!n || !n.nodeValue) return NodeFilterRef.FILTER_REJECT;
          if (isLockedNode(n)) return NodeFilterRef.FILTER_REJECT;
          return NodeFilterRef.FILTER_ACCEPT;
        }
      }, false);
    }catch(e){ return String(html); }
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt).replace(/\r\n/g, "\n");
    if (!s) return "";
    var parts = s.split(/\n{2,}/);
    var out = [];
    for (var i=0;i<parts.length;i++){
      out.push("<p>" + escapeHTML(parts[i]).replace(/\n/g, "<br />") + "</p>");
    }
    return out.join("");
  }

  var TEXTS = {
    fr: {
      title: "Balakallpa",
      kicker: "Katûpirsia 5 — La Matrice-substrat • Régime d’émanations transductives",
      h_def: "Définition",
      chip_1: "Idéogramme conceptuel",
      chip_2: "Élément",
      chip_3: "Bande de fréquences potentielles",
      def_short: "Balakallpa nomme l’ensemble des formes émanées issues des interactions fréquentielles entre les éléments structurants de la Katûvýs, les organes internes de Katûsýs, et les forces actives mobilisées par les modalités, les accords, les synchrêssions et les intentions matricielles.",
      def_long: "Balakallpa est explicitement posé comme une bande de fréquences potentielles d’où s’expriment La Katûpirsia, Le Katûvýsqun, L’Àpákan, la MOCoN, ainsi que d’autres non encore révélés.\n\nCes émanations ne relèvent pas directement de l’Organon posœnnoïal : elles en constituent la manifestation transductive. Elles portent mémoire, fonction ou vibration d’un passage, d’un seuil, d’un acte codé de propagation.\n\nAucune n’est fixation : chaque Balakallpa demeure oscillation active entre matrice et système, variation de vitesse dans un même champ. L’émanation n’est jamais rupture ; elle est soulèvement local du milieu activé.",
      h_features: "Déploiement",
      hint_fold: "déplier",
      features: [
        "Écriture canonique : épicène invariable, sans article.",
        "Statut canonique : bande de fréquences potentielles d’où s’expriment Katûpirsia, Katûvýsqun, Àpákan, MOCoN et d’autres formes non encore révélées.",
        "Régime transductif : manifestation fonctionnelle baignant dans la Katûvýs sans être un organe immanent.",
        "Portage : mémoire, fonction, vibration d’un passage, d’un seuil, d’un acte codé de propagation.",
        "Respiration interne : double pulsation densifiante (posœnnoïaque) et épurative (posœnnoïque), marée interne de la matrice-substrat."
      ],
      h_questions: "Tests d’usage",
      hint_fold2: "déplier",
      questions: [
        "Quand une forme surgit comme prolongement du système sans appartenir à l’Organon : je reconnais Balakallpa.",
        "Quand un passage doit rester mobile tout en devenant opérant : j’active Balakallpa.",
        "Quand une mémoire doit circuler comme vibration de seuil : Balakallpa porte."
      ],
      example_title: "Exemple opératif",
      example_text: "Dans une pratique, une émanation devient fonctionnelle — un seuil, un acte, une forme. Je la nomme Balakallpa afin de la tenir comme oscillation active entre matrice et système.",
      h_family: "Position & relations",
      hint_fold3: "déplier",
      family_1: "<p><strong>Position</strong> — Balakallpa désigne un régime d’émanation : il se situe au contact de la Katûvýs, rendu opérant par l’interaction des organes de Katûsýs et des composantes actives du système.</p>",
      family_2: "<p><strong>Différence structurante</strong> — Katûsýs relève de l’intériorité constitutive ; Balakallpa relève de la manifestation. L’un constitue le corps spiralé, l’autre décrit les formes qui deviennent fonctionnelles comme soulèvement local du milieu activé.</p>",
      h_wordbuild: "Formation du nom",
      wordbuild_blocks: [
        { head: "Origine segmentée", text: "Bala (sanskrit) : force, puissance intérieure, énergie dirigée. Kallpa (quechua) : énergie vitale, puissance cosmique, force vivante." },
        { head: "Charge opérative", text: "Le mot installe une double densité : force orientée et force vivante cosmique. Il convient ainsi au statut de Balakallpa : puissance qui prend forme sans se réduire à une forme." },
        { head: "Usage", text: "Dire Balakallpa revient à situer une forme comme manifestation transductive, tenue dans la mobilité et dans la propagation plutôt que dans la fixation." }
      ],
      wordbuild_notes: [
        "Le terme sert d’outil de repérage : il nomme la fonction de seuil et la propagation sans réifier la forme."
      ],
      cta_translate: "Proposer une traduction du concept",
      title_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      title_img_alt: "Balakallpa",
      chip_1_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      chip_1_img_alt: "Balakallpa",
      chip_2_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535",
      chip_2_img_alt: "La Katûvýs",
      chip_3_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      chip_3_img_alt: "Balakallpa"
    },
    en: {
      title: "Balakallpa",
      kicker: "Katûpirsia 5 — The Matrix-substrate • Regime of transductive emanations",
      h_def: "Definition",
      chip_1: "Conceptual ideogram",
      chip_2: "Element",
      chip_3: "Band of potential frequencies",
      def_short: "Balakallpa names the set of emanated forms arising from the frequency-based interactions between the structuring elements of the Katûvýs, the internal organs of Katûsýs, and the active forces mobilized by modalities, accords, synchrêssions and matricial intentions.",
      def_long: "Balakallpa is explicitly set as a band of potential frequencies from which La Katûpirsia, Le Katûvýsqun, L’Àpákan, MOCoN, and other not yet revealed forms express themselves.\n\nThese emanations do not belong directly to the posœnnoïal Organon: they constitute its transductive manifestation. They carry memory, function, or the vibration of a threshold and a coded act of propagation.\n\nNothing is fixed: each Balakallpa remains an active oscillation between matrix and system, a variation of speed within the same field. The emanation is never a rupture; it is a local lifting of the activated milieu.",
      h_features: "Unfolding",
      hint_fold: "expand",
      features: [
        "Canonical writing: epicene, invariable, used without an article.",
        "Canonical status: band of potential frequencies from which Katûpirsia, Katûvýsqun, Àpákan, MOCoN and other not yet revealed forms express themselves.",
        "Transductive regime: a functional manifestation bathing in Katûvýs without being an immanent organ.",
        "Bearing: memory, function, the vibration of a threshold, and a coded act of propagation.",
        "Inner respiration: a double pulsation, densifying and refining, as the internal tide of the matrix-substrate."
      ],
      h_questions: "Use tests",
      hint_fold2: "expand",
      questions: [
        "When a form emerges as a prolongation of the system without belonging to the Organon: I recognize Balakallpa.",
        "When a passage must remain mobile while becoming operative: I activate Balakallpa.",
        "When memory must circulate as threshold-vibration: Balakallpa carries."
      ],
      example_title: "Operative example",
      example_text: "In practice, an emanation becomes functional — a threshold, an act, a form. I name it Balakallpa so as to hold it as an active oscillation between matrix and system.",
      h_family: "Position & relations",
      hint_fold3: "expand",
      family_1: "<p><strong>Position</strong> — Balakallpa denotes a regime of emanation: it stands at the contact zone of Katûvýs, made operative through the interaction of Katûsýs organs and the active components of the system.</p>",
      family_2: "<p><strong>Key difference</strong> — Katûsýs belongs to constitutive interiority; Balakallpa belongs to manifestation. The first constitutes the spiral body, the second names forms that become functional as a local lifting of the activated milieu.</p>",
      h_wordbuild: "Name formation",
      wordbuild_blocks: [
        { head: "Segmented origin", text: "Bala (Sanskrit): force, inner power, directed energy. Kallpa (Quechua): vital energy, cosmic power, living force." },
        { head: "Operative charge", text: "The word installs a double density: oriented force and living cosmic force. It thus suits Balakallpa’s status: a power that takes form without being reduced to a form." },
        { head: "Use", text: "Saying Balakallpa situates a form as a transductive manifestation, held in mobility and propagation rather than in fixation." }
      ],
      wordbuild_notes: [
        "The term is a locating tool: it names threshold-function and propagation without reifying the form."
      ],
      cta_translate: "Suggest a translation of the concept",
      title_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      title_img_alt: "Balakallpa",
      chip_1_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      chip_1_img_alt: "Balakallpa",
      chip_2_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535",
      chip_2_img_alt: "La Katûvýs",
      chip_3_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      chip_3_img_alt: "Balakallpa"
    },
    es: {
      title: "Balakallpa",
      kicker: "Katûpirsia 5 — La Matriz-substrato • Régimen de emanaciones transductivas",
      h_def: "Definición",
      chip_1: "Ideograma conceptual",
      chip_2: "Elemento",
      chip_3: "Banda de frecuencias potenciales",
      def_short: "Balakallpa nombra el conjunto de formas emanadas que surgen de las interacciones frecuenciales entre los elementos estructurantes de la Katûvýs, los órganos internos de Katûsýs y las fuerzas activas movilizadas por modalidades, acuerdos, synchrêssions e intenciones matriciales.",
      def_long: "Balakallpa está explícitamente planteado como una banda de frecuencias potenciales de donde se expresan La Katûpirsia, Le Katûvýsqun, L’Àpákan, MOCoN y otras formas aún no reveladas.\n\nEstas emanaciones no pertenecen directamente al Organon posœnnoïal: constituyen su manifestación transductiva. Portan memoria, función o vibración de umbral, y un acto codificado de propagación.\n\nNada queda fijado: cada Balakallpa permanece como oscilación activa entre matriz y sistema, variación de velocidad dentro del mismo campo. La emanación nunca es ruptura; es levantamiento local del medio activado.",
      h_features: "Despliegue",
      hint_fold: "desplegar",
      features: [
        "Escritura canónica: epiceno, invariable y sin artículo.",
        "Estatus canónico: banda de frecuencias potenciales de donde se expresan Katûpirsia, Katûvýsqun, Àpákan, MOCoN y otras formas aún no reveladas.",
        "Régimen transductivo: manifestación funcional que baña en Katûvýs sin ser órgano inmanente.",
        "Portación: memoria, función, vibración de umbral y acto codificado de propagación.",
        "Respiración interna: doble pulsación, densificante y depurativa, como marea interna de la matriz-substrato."
      ],
      h_questions: "Pruebas de uso",
      hint_fold2: "desplegar",
      questions: [
        "Cuando una forma surge como prolongación del sistema sin pertenecer al Organon: reconozco Balakallpa.",
        "Cuando un pasaje debe permanecer móvil y a la vez volverse operativo: activo Balakallpa.",
        "Cuando la memoria debe circular como vibración de umbral: Balakallpa porta."
      ],
      example_title: "Ejemplo operativo",
      example_text: "En práctica, una emanación se vuelve funcional — umbral, acto, forma. La nombro Balakallpa para sostenerla como oscilación activa entre matriz y sistema.",
      h_family: "Posición y relaciones",
      hint_fold3: "desplegar",
      family_1: "<p><strong>Posición</strong> — Balakallpa nombra un régimen de emanación: se sitúa en la zona de contacto de la Katûvýs, hecho operativo por la interacción de los órganos de Katûsýs y de los componentes activos del sistema.</p>",
      family_2: "<p><strong>Diferencia clave</strong> — Katûsýs pertenece a la interioridad constitutiva; Balakallpa pertenece a la manifestación. El primero constituye el cuerpo espiralado, el segundo nombra formas que se vuelven funcionales como levantamiento local del medio activado.</p>",
      h_wordbuild: "Formación del nombre",
      wordbuild_blocks: [
        { head: "Origen segmentado", text: "Bala (sánscrito): fuerza, potencia interior, energía dirigida. Kallpa (quechua): energía vital, potencia cósmica, fuerza viva." },
        { head: "Carga operativa", text: "La palabra instala una doble densidad: fuerza orientada y fuerza viva cósmica. Así conviene al estatuto de Balakallpa: potencia que toma forma sin reducirse a una forma." },
        { head: "Uso", text: "Decir Balakallpa sitúa una forma como manifestación transductiva, sostenida en la movilidad y en la propagación más que en la fijación." }
      ],
      wordbuild_notes: [
        "El término funciona como herramienta de localización: nombra función de umbral y propagación sin reificar la forma."
      ],
      cta_translate: "Proponer una traducción del concepto",
      title_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      title_img_alt: "Balakallpa",
      chip_1_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      chip_1_img_alt: "Balakallpa",
      chip_2_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535",
      chip_2_img_alt: "La Katûvýs",
      chip_3_img_src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Balakallpa_copie.png?v=1772893364",
      chip_3_img_alt: "Balakallpa"
    }
  };

  function getTargetRoots(){ return qsa(document, ROOT_SEL); }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (el) el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (el) el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var s = clampStr(src), a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt", ""); }catch(e){}
      try{ el.style.visibility = "hidden"; }catch(e){}
      return;
    }
    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.visibility = ""; }catch(e){}
  }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push("<li>" + protectKeywordsHTML(escapeHTML(clampStr(arr[i]))) + "</li>");
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var t = clampStr(exampleTitle), x = clampStr(exampleText);
    if (!t && !x){ el.innerHTML = ""; return; }
    el.innerHTML = '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(escapeHTML(t)) + '</strong></div>' +
      '<div class="po-lex-example__text">' + protectKeywordsHTML(escapeHTML(x)) + '</div>';
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push('<div class="po-axis-wb"><div class="po-axis-wb__h">' + protectKeywordsHTML(escapeHTML(clampStr(b.head))) + '</div><div class="po-axis-wb__t">' + protectKeywordsHTML(escapeHTML(clampStr(b.text))) + '</div></div>');
    }
    el.innerHTML = out.join("");
  }

  function lockNode(root, slot){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    el.setAttribute("translate", "no");
    if ((el.className || "").indexOf("notranslate") === -1) el.className = (el.className ? el.className + ' ' : '') + 'notranslate';
  }

  function applyButtons(root, lang){
    qsa(root, '.po-langbtn').forEach(function(btn){
      var isActive = (normLang(btn.getAttribute('data-po-lang')) === lang);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function buildUiTexts(lang){
    var t = TEXTS[lang] || TEXTS.fr;
    var entry = getLexiconEntry(AXIS_LEX_ID) || getLexiconEntry('Balakallpa') || null;
    var titleFR = (entry ? pickTerm(entry, 'fr') : '') || TEXTS.fr.title;
    var defShort = (entry ? pickDefShort(entry, lang) : '') || t.def_short;
    var defLong = (entry ? pickDefLong(entry, lang) : '') || t.def_long;
    var out = {};
    for (var k in t) out[k] = t[k];
    out.title = titleFR;
    out.def_short = defShort;
    out.def_long = defLong;
    return out;
  }

  function renderRoot(root, lang){
    var t = buildUiTexts(lang);
    setSlotImg(root, 'title_img', t.title_img_src, t.title_img_alt || t.title);
    setSlotText(root, 'title', t.title);
    setSlotText(root, 'kicker', t.kicker);
    setSlotText(root, 'h_def', t.h_def);
    setSlotText(root, 'chip_1', t.chip_1);
    setSlotText(root, 'chip_2', t.chip_2);
    setSlotText(root, 'chip_3', t.chip_3);
    setSlotImg(root, 'chip_1_img', t.chip_1_img_src, t.chip_1_img_alt || t.chip_1);
    setSlotImg(root, 'chip_2_img', t.chip_2_img_src, t.chip_2_img_alt || t.chip_2);
    setSlotImg(root, 'chip_3_img', t.chip_3_img_src, t.chip_3_img_alt || t.chip_3);
    setSlotHTML(root, 'def_short', htmlParagraphize(t.def_short));
    setSlotHTML(root, 'def_long', htmlParagraphize(t.def_long));
    setSlotText(root, 'h_features', t.h_features);
    setSlotText(root, 'hint_fold', t.hint_fold);
    renderList(root, 'features', t.features);
    setSlotText(root, 'h_questions', t.h_questions);
    setSlotText(root, 'hint_fold2', t.hint_fold2);
    renderList(root, 'questions', t.questions);
    renderExampleBox(root, 'example_box', t.example_title, t.example_text);
    setSlotText(root, 'h_family', t.h_family);
    setSlotText(root, 'hint_fold3', t.hint_fold3);
    setSlotHTML(root, 'family_1', t.family_1);
    setSlotHTML(root, 'family_2', t.family_2);
    setSlotText(root, 'h_wordbuild', t.h_wordbuild);
    renderWordBlocks(root, 'wordbuild_blocks', t.wordbuild_blocks);
    renderList(root, 'wordbuild_notes', t.wordbuild_notes);
    setSlotText(root, 'cta_translate', t.cta_translate);
    lockNode(root, 'title');
    applyButtons(root, lang);
    ensureAudioButtons(root, lang);
    refreshAudioButtons(root, lang);
  }

  function renderAll(lang){
    var l = normLang(lang) || getLang() || 'fr';
    getTargetRoots().forEach(function(root){ renderRoot(root, l); });
  }

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:'', lang:'fr', voice:null };
  var AUDIO_UI = {
    fr: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    en: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    es: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){ return AUDIO_UI[normLang(lang)] || AUDIO_UI.fr; }

  function ensureAudioStyles(){
    if (document.getElementById('po-k5-balakallpa-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'po-k5-balakallpa-audio-styles';
    style.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:12px 0 14px;}',
      '.po-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.45);background:rgba(0,0,0,.01);color:var(--color-accent,#1f7a3a);border-radius:999px;padding:8px 14px;font:inherit;font-size:12px;line-height:1;cursor:pointer;transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease,background .18s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}',
      '.po-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.65);}',
      '.po-audio-btn.is-active{border-color:rgba(184,134,11,.85);background:rgba(31,122,58,.04);box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);}',
      '.po-lex-summary .po-audio-btn{margin-left:auto;flex:0 0 auto;}',
      '@media (max-width:700px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-audio-btn{order:3;margin-left:0;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-audio-btn notranslate';
    btn.setAttribute('translate', 'no');
    btn.setAttribute('data-po-audio-role', role);
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();
    var panel = qs(root, '.po-lex-panel');
    if (panel){
      var generalWrap = qs(root, '.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap notranslate';
        generalWrap.setAttribute('translate', 'no');
        generalWrap.setAttribute('data-po-audio-role', 'general');
        generalWrap.appendChild(createAudioButton('general'));
        var meta = qs(root, '.po-axis-meta');
        var defShort = qs(root, '[data-po-slot="def_short"]');
        var firstDetail = qs(panel, '.po-lex-details');
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling); else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else{
          panel.appendChild(generalWrap);
        }
      }
    }
    qsa(root, '.po-lex-details').forEach(function(details, idx){
      var summary = qs(details, '.po-lex-summary');
      if (!summary) return;
      var btn = qs(summary, '.po-audio-btn[data-po-audio-role="block"]');
      if (!btn){
        btn = createAudioButton('block');
        btn.setAttribute('data-po-audio-index', String(idx));
        summary.appendChild(btn);
      }
    });
    bindAudioButtons(root, lang);
  }

  function refreshAudioButtons(root, lang){
    var ui = audioUI(lang);
    qsa(root, '.po-audio-btn').forEach(function(btn){
      var role = btn.getAttribute('data-po-audio-role');
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === (role === 'general' ? 'general' : ('block:' + (btn.getAttribute('data-po-audio-index') || '0'))));
      btn.textContent = active ? ui.stop : (role === 'general' ? ui.general : ui.block);
      btn.classList.toggle('is-active', !!active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function bindAudioButtons(root){
    qsa(root, '.po-audio-btn').forEach(function(btn){
      if (btn.__poAudioBound) return;
      btn.__poAudioBound = true;
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = btn.getAttribute('data-po-audio-role');
        var key = role === 'general' ? 'general' : ('block:' + (btn.getAttribute('data-po-audio-index') || '0'));
        if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
          stopAudio();
          refreshAudioButtons(root, getLang());
          return;
        }
        startAudio(root, getLang(), key);
      });
    });
  }

  function textFromNode(node){
    if (!node) return '';
    var clone = node.cloneNode(true);
    qsa(clone, 'script,style,.po-audio-btn,.po-lex-summary__hint').forEach(function(el){ if (el && el.parentNode) el.parentNode.removeChild(el); });
    return clampStr(clone.textContent || clone.innerText || '').replace(/\s+/g, ' ').replace(/\s([:;!?])/g, '$1').trim();
  }

  function buildIntroText(root){
    var parts = [];
    ['title','kicker','h_def','chip_1','chip_2','chip_3','def_short','def_long'].forEach(function(slot){
      var txt = textFromNode(qs(root, '[data-po-slot="' + slot + '"]'));
      if (txt) parts.push(txt);
    });
    return parts.join('. ');
  }

  function buildBlockText(details){
    if (!details) return '';
    var parts = [];
    var summary = qs(details, '.po-lex-summary');
    if (summary){
      var title = textFromNode(qs(summary, '.po-lex-summary__title'));
      if (title) parts.push(title);
    }
    var clone = details.cloneNode(true);
    clone.open = true;
    qsa(clone, '.po-audio-btn,.po-lex-summary__hint').forEach(function(el){ if (el && el.parentNode) el.parentNode.removeChild(el); });
    var txt = textFromNode(clone);
    if (txt) parts.push(txt);
    return parts.join('. ');
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, ' ').trim();
    if (!raw) return [];
    var sentences = raw.match(/[^.!?]+[.!?…]?/g) || [raw];
    var chunks = [];
    var current = '';
    sentences.forEach(function(sentence){
      var s = sentence.trim();
      if (!s) return;
      if (!current){ current = s; return; }
      if ((current + ' ' + s).length <= 210) current += ' ' + s;
      else { chunks.push(current); current = s; }
    });
    if (current) chunks.push(current);
    return chunks;
  }

  function pickVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    var target = lang === 'en' ? 'en' : (lang === 'es' ? 'es' : 'fr');
    for (var i=0;i<voices.length;i++){
      var vlang = clampStr(voices[i].lang).toLowerCase();
      if (vlang.indexOf(target) === 0) return voices[i];
    }
    return voices[0] || null;
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH){ try{ PO_AUDIO_SYNTH.cancel(); }catch(e){} }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = 'fr';
    PO_AUDIO_STATE.voice = null;
    getTargetRoots().forEach(function(root){ refreshAudioButtons(root, getLang()); });
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){ speakNextUnit(true); return; }
    var chunk = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!chunk){ speakNextChunk(); return; }
    var utter = new SpeechSynthesisUtterance(chunk);
    utter.lang = PO_AUDIO_STATE.lang === 'en' ? 'en-US' : (PO_AUDIO_STATE.lang === 'es' ? 'es-ES' : 'fr-FR');
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.rate = 1;
    utter.pitch = 1;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ speakNextChunk(); }
  }

  function speakNextUnit(fromNext){
    if (!PO_AUDIO_STATE.root) return;
    if (!fromNext && PO_AUDIO_STATE.unitPos < 0) PO_AUDIO_STATE.unitPos = 0;
    if (fromNext) PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){ stopAudio(); return; }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (unit.node && unit.node.tagName && unit.node.tagName.toLowerCase() === 'details') unit.node.open = true;
    var text = unit.text;
    var chunks = splitTextForSpeech(text);
    if (!chunks.length){ speakNextUnit(true); return; }
    PO_AUDIO_STATE.chunks = chunks;
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = unit.key;
    refreshAudioButtons(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang);
    speakNextChunk();
  }

  function buildUnits(root, key){
    var units = [];
    if (key === 'general'){
      var intro = buildIntroText(root);
      if (intro) units.push({ key:'general', node:root, text:intro });
      qsa(root, '.po-lex-details').forEach(function(details, idx){
        var txt = buildBlockText(details);
        if (txt) units.push({ key:'block:' + idx, node:details, text:txt });
      });
      return units;
    }
    var idx = parseInt(String(key).split(':')[1], 10);
    if (isNaN(idx)) idx = 0;
    qsa(root, '.po-lex-details').forEach(function(details, pos){
      if (pos < idx) return;
      var txt = buildBlockText(details);
      if (txt) units.push({ key:'block:' + pos, node:details, text:txt });
    });
    return units;
  }

  function startAudio(root, lang, key){
    if (!PO_AUDIO_SYNTH || !root) return;
    try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, key);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = normLang(lang) || 'fr';
    PO_AUDIO_STATE.voice = pickVoice(PO_AUDIO_STATE.lang);
    refreshAudioButtons(root, PO_AUDIO_STATE.lang);
    if (!PO_AUDIO_STATE.units.length){ stopAudio(); return; }
    speakNextUnit(false);
  }

  if (PO_AUDIO_SYNTH && PO_AUDIO_SYNTH.onvoiceschanged !== undefined){
    PO_AUDIO_SYNTH.onvoiceschanged = function(){ getTargetRoots().forEach(function(root){ refreshAudioButtons(root, getLang()); }); };
  }

  function bindLanguageButtons(root){
    if (!root || root.__poBalakallpaLangBound) return;
    root.__poBalakallpaLangBound = true;
    qsa(root, '.po-langbtn').forEach(function(btn){
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        var l = normLang(btn.getAttribute('data-po-lang')) || 'fr';
        setLang(l);
      });
    });
  }

  function protectNode(node){
    if (!node || node.nodeType !== 1) return;
    if (node.classList && node.classList.contains('notranslate')) node.setAttribute('translate', 'no');
    qsa(node, '.notranslate,.po-lex-protect').forEach(function(el){ el.setAttribute('translate', 'no'); });
  }

  function keepProtected(root){
    if (!root || !window.MutationObserver || root.__poBalakallpaObserverBound) return;
    root.__poBalakallpaObserverBound = true;
    protectNode(root);
    var mo = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        if (!m.addedNodes) return;
        Array.prototype.forEach.call(m.addedNodes, function(node){ protectNode(node); });
      });
    });
    mo.observe(root, { childList:true, subtree:true });
  }

  function initRoot(root){
    if (!root) return;
    bindLanguageButtons(root);
    keepProtected(root);
    renderRoot(root, getLang());
  }

  function init(){
    var existing = readStoredLang();
    if (!existing) storeLang(detectBrowserLang());
    getTargetRoots().forEach(initRoot);
  }

  function setLang(raw){
    var l = storeLang(raw || 'fr');
    __PO_PROTECT_CACHE__.key = '';
    renderAll(l);
    notifyLocaleChanged();
    return l;
  }

  window.addEventListener('po:lexicon-ready', function(){
    __PO_PROTECT_CACHE__.key = '';
    renderAll(getLang());
  });

  try{
    var htmlMo = new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){
        if (muts[i].type === 'attributes' && muts[i].attributeName === 'lang'){
          renderAll(getLang());
          notifyLocaleChanged();
          break;
        }
      }
    });
    if (document && document.documentElement) htmlMo.observe(document.documentElement, { attributes:true });
  }catch(e){}

  window.PoKatupirsia5BalakallpaTextsFR_EN_ES_20260303 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;

  function boot(){ try{ init(); }catch(e){} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true });
  else boot();

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:block:select', boot);
  document.addEventListener('shopify:block:deselect', boot);
})();
